import _LocationCity from "@mui/icons-material/LocationCity";
import _Train from "@mui/icons-material/Train";
import { AccomodationIcon, AnticsIcon, BeachIcon, BicycleHomeIcon, BicycleRentalIcon, BicycleRepairIcon, BusStopIcon, CampingIcon, CastleIcon, ChargingStationIcon, CollectiveIcon, FastFoodIcon, FortificationIcon, FountainIcon, GardenIcon, IndustryIcon, MuseumIcon, NaturalSiteIcon, ParkingIcon, PicnicIcon, PumpIcon, ReligiousIcon, RemarkableCityIcon, RestaurantIcon, RuinsIcon, SmallHeritageIcon, SportIcon, ThermalStationIcon, ToDoToSeeIcon, ToiletsIcon, TourismOfficeIcon, TramStopIcon, UsefulIcon, ViewPointIcon, WaterPointIcon } from '../components/icons';
export const placeTypeIcons = {
  accomodation: AccomodationIcon,
  antics: AnticsIcon,
  beach: BeachIcon,
  bicycleHome: BicycleHomeIcon,
  bicyclePump: PumpIcon,
  bicycleRental: BicycleRentalIcon,
  bicycleRepair: BicycleRepairIcon,
  bicycleParking: ParkingIcon,
  camping: CampingIcon,
  castle: CastleIcon,
  chargingStation: ChargingStationIcon,
  collective: CollectiveIcon,
  drinkingWater: WaterPointIcon,
  fortification: FortificationIcon,
  garden: GardenIcon,
  hotel: AccomodationIcon,
  industry: IndustryIcon,
  museum: MuseumIcon,
  naturalSite: NaturalSiteIcon,
  picnic: PicnicIcon,
  remarkableCity: RemarkableCityIcon,
  restaurant: RestaurantIcon,
  fastFood: FastFoodIcon,
  ruins: RuinsIcon,
  thermalCenter: ThermalStationIcon,
  toDoToSee: ToDoToSeeIcon,
  toilets: ToiletsIcon,
  tourismOffice: TourismOfficeIcon,
  useful: UsefulIcon,
  viewPoint: ViewPointIcon,
  trainStation: _Train,
  busStop: BusStopIcon,
  tramStop: TramStopIcon,
  information: TourismOfficeIcon,
  fountain: FountainIcon,
  city: _LocationCity,
  town: _LocationCity,
  smallHeritage: SmallHeritageIcon,
  religious: ReligiousIcon,
  sport: SportIcon
};
export class Place {
  constructor(id, _point, addressDetail, poiId, placeType) {
    this.id = id;
    this._point = _point;
    this.addressDetail = addressDetail;
    this.poiId = poiId;
    this.placeType = placeType;
    if (typeof _point === 'string') {
      const [lng, lat] = _point.substring(_point.indexOf('(') + 1).replace(')', '').split(' ').map(coord => parseFloat(coord));
      this.point = {
        type: 'Point',
        coordinates: [lng, lat]
      };
    } else this.point = _point;
  }
  get strPoint() {
    return `[${this.point.coordinates.map(coord => coord.toFixed(6)).join(', ')}]`;
  }
  get asParam() {
    return `${this.point.coordinates.map(coord => coord.toFixed(6)).join(',')}`;
  }
  get address() {
    return this.addressDetail?.primaryText ? `${this.addressDetail.primaryText}${this.addressDetail.secondaryText ? `, ${this.addressDetail.secondaryText}` : ''}` : this.point ? this.strPoint : '';
  }
  clone() {
    return new Place(this.id, {
      ...this.point
    }, this.addressDetail ? {
      ...this.addressDetail
    } : undefined);
  }
}